export const COST_PER_ALERT = 7;
export const SWARM_SIZES = [
  "Softball" as const,
  "Basketball" as const,
  "Very Large" as const,
];
export const SWARM_LOCATIONS = [
  "Tree Branch" as const,
  "Tree Trunk" as const,
  "Bush/Shrub" as const,
  "Ground" as const,
  "House Exterior" as const,
  "Roof" as const,
  "Eaves/Soffit" as const,
  "Wall/Siding" as const,
  "Fence/Gate" as const,
  "Water Meter" as const,
  "Utility Box" as const,
  "Yard Furniture" as const,
  "Garden" as const,
  "Inside a Structure" as const,
];
export const BAD_REPORT_TYPES = [
  "Not honey bees" as const,
  "Swarm moved into structure" as const,
  "Swarm moved on" as const,
  "Someone else got the swarm" as const,
  "Other" as const,
];

export const DATE_RANGES = [
  "Current Day" as const,
  "Current Month" as const,
  "Year To Date" as const,
  "Past Month" as const,
  "Past 3 Months" as const,
  "Past 6 Months" as const,
  "Past Year" as const,
  "All" as const,
];
